@if (data$ | async; as data) {
  @if (data.imageMapHTML && data.visible === 'true') {
    <div class="how-section1 mySlides fadespot" [attr.data-visiblae]="data.visible">
      @if (data.imageMapHTML && data.visible === 'true') {
        <h2>Product Spotlight</h2>
      }
      @if (data.visible === 'true') {
        <div class="row" [ngClass]="{'noShow': data.visible === 'false'}"
          (click)="data.urlLink ? navSpotlightPlp(data.urlLink) : null" [style.cursor]="data.urlLink ? 'pointer' : null">
          @if (data.media) {
            <div class="col-md-6 how-img">
              <img [src]="getImgUrl(data.media.url)" class=" img-fluid" alt=""/>
            </div>
          }
          <div class="col-md-6 p-text">
            <p [innerHTML]="data.imageMapHTML"></p>
          </div>
        </div>
      }
    </div>
  }
}
